var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftLong(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M119.749 377.594L7.679 273.592C-2.56 264.094 -2.56 247.904 7.679 238.404L119.749 134.404C126.741 127.92 136.933 126.186 145.687 130C154.444 133.81 160.104 142.451 160.104 151.998V216H471.999C494.093 216 511.999 233.906 511.999 256S494.093 296 471.999 296H160.104V360C160.104 369.547 154.444 378.187 145.687 382.002C136.933 385.812 126.741 384.078 119.749 377.594Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftLong);
export default __webpack_public_path__ + "static/media/left-long.0e1e5ccd9147f2f920dc726ec5618a74.svg";
export { ForwardRef as ReactComponent };